export default {
    role: null,
    pofile_pic : '',
    full_name: ''
}